document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("component-carousel")) {
    class Carousel extends HTMLElement {
      constructor() {
        super();
        this.carousel = this.querySelector("[data-carousel]");
        this.offset = 0;
        this.speed = this.dataset.speed ? Number(this.dataset.speed) : 60;
        this.mouseoverPause = this.dataset.pause === "true";
        this.lastTime = null;
        this.itemGap = window.innerWidth < 849 ? 10 : 16;
        this.shouldReduceMotion = false;
        this.isAnimating = false;
        this.animationFrameId = null;
        this._resizeObserver = null;
        this._intersectionObserver = null;

        if (!this.carousel.hasAttribute('data-carousel-cloned')) {
          const originalContent = Array.from(this.carousel.children);
          this.originalWidth = this.carousel.scrollWidth + this.itemGap;
          originalContent.forEach(item => {
            this.carousel.appendChild(item.cloneNode(true));
          });
          this.carousel.setAttribute('data-carousel-cloned', 'true');
        } else {
          this.originalWidth = this.carousel.scrollWidth / 2 + this.itemGap;
        }
        this.carousel.style.willChange = 'transform';
      }

      connectedCallback() {
        this.checkReduceMotion();
        this.initObservers();
        if (this.carousel && this.mouseoverPause) {
          this._onMouseEnter = () => {
            this.isAnimating = false;
            if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
          };
          this._onMouseLeave = () => {
            if (!this.shouldReduceMotion && this._isInViewport()) {
              if (!this.isAnimating) {
                this.isAnimating = true;
                this.lastTime = null;
                this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
              }
            }
          };
          this.carousel.addEventListener('mouseenter', this._onMouseEnter);
          this.carousel.addEventListener('mouseleave', this._onMouseLeave);
        }
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._intersectionObserver) this._intersectionObserver.disconnect();
        if (this.carousel && this.mouseoverPause) {
          this.carousel.removeEventListener('mouseenter', this._onMouseEnter);
          this.carousel.removeEventListener('mouseleave', this._onMouseLeave);
        }
      }
      _isInViewport() {
        const rect = this.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
      }

      checkReduceMotion() {
        this.shouldReduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;
      }

      initObservers() {
        this._intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              this.handleIntersect(true);
            });
          },
          { threshold: 0 }
        );
        this._intersectionObserver.observe(this);

        this._resizeObserver = new ResizeObserver(() => {
          this.itemGap = window.innerWidth < 849 ? 10 : 16;
          this.originalWidth = this.carousel.scrollWidth / 2 + this.itemGap;
        });
        this._resizeObserver.observe(this.carousel);
      }

      handleIntersect(isIntersecting) {
        if (isIntersecting && !this.shouldReduceMotion) {
          if (!this.isAnimating) {
            this.isAnimating = true;
            this.lastTime = null;
            this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
          }
        } else {
          this.isAnimating = false;
          if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
        }
      }

      animate(timestamp) {
        if (!this.isAnimating) return;
        if (!this.lastTime) this.lastTime = timestamp;
        const delta = timestamp - this.lastTime;
        this.lastTime = timestamp;
        this.offset += (this.speed * delta) / 1000;
        if (this.offset >= this.originalWidth) {
          this.offset = 0;
        }
        this.carousel.style.transform = `translate3d(-${this.offset}px, 0, 0)`;
        this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
      }
    }
    customElements.define("component-carousel", Carousel);
  }
});